import {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "./firebase";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  // const applyFirebaseUser = useCallback(async (firebaseUser) => {
  //   try {
  //     if (firebaseUser && firebaseUser.emailVerified) {
  //       setUser(firebaseUser);
  //       const snap = await getDoc(doc(db, "users", firebaseUser.uid));
  //       setProfile(snap.exists() ? snap.data() : null);
  //     } else {
  //       setUser(null);
  //       setProfile(null);
  //     }
  //   } catch (err) {
  //     console.error("Auth state error:", err);
  //     setUser(null);
  //     setProfile(null);
  //   }
  // }, []);

  const applyFirebaseUser = useCallback(async (firebaseUser) => {
    try {
      const isUnverifiedPasswordAccount =
        firebaseUser?.providerData?.some((p) => p.providerId === "password") &&
        !firebaseUser.emailVerified;

      if (firebaseUser && !isUnverifiedPasswordAccount) {
        setUser(firebaseUser);
        const snap = await getDoc(doc(db, "users", firebaseUser.uid));
        setProfile(snap.exists() ? snap.data() : null);
      } else {
        setUser(null);
        setProfile(null);
      }
    } catch (err) {
      console.error("Auth state error:", err);
      setUser(null);
      setProfile(null);
    }
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      await applyFirebaseUser(firebaseUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [applyFirebaseUser]);

  const refreshUser = useCallback(async () => {
    const current = auth.currentUser;
    await applyFirebaseUser(current);
  }, [applyFirebaseUser]);

  return (
    <AuthContext.Provider value={{ user, profile, loading, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
